"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactTableRowOptionsDropdown = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var reactstrap_1 = require("reactstrap");
var icons_1 = require("../../../icons");
var ReactTableRowOptionsDropdown = function (_a) {
    var rowOptions = _a.rowOptions, row = _a.row;
    return ((0, jsx_runtime_1.jsxs)(reactstrap_1.UncontrolledDropdown, __assign({ direction: "start", className: "d-flex" }, { children: [(0, jsx_runtime_1.jsx)(reactstrap_1.DropdownToggle, __assign({ color: "darker-quartenary", className: "rounded-circle p-0" }, { children: (0, jsx_runtime_1.jsx)(icons_1.Kebab24, {}) })), (0, jsx_runtime_1.jsx)(reactstrap_1.DropdownMenu, __assign({ container: "body", className: "dropdown-menu-lg", style: { minWidth: '192px' } }, { children: rowOptions.map(function (_a) {
                    var Icon = _a.Icon, label = _a.label, onClick = _a.onClick;
                    return ((0, jsx_runtime_1.jsxs)(reactstrap_1.DropdownItem, __assign({ onClick: function () { return onClick(row); } }, { children: [label, Icon && ((0, jsx_runtime_1.jsx)("span", __assign({ className: "dropdown-suffix x5-me-n1" }, { children: (0, jsx_runtime_1.jsx)(Icon, {}) })))] }), label));
                }) }))] })));
};
exports.ReactTableRowOptionsDropdown = ReactTableRowOptionsDropdown;
